import { LegalPage } from '@/components/LegalPage';
import { help } from '@/legal/content';

export default function Help() {
  return <LegalPage doc={help} />;
}
